// Converted to .ts file on 23 June, 2025
import store from '@/redux/store';
import { getSSRStore } from 'src/redux';
/**
 * returns name of category given categoryID or TagId
 * @param {number} id categoryId or TagId
 * @return {string} name of category or Tag
 */
function getCategoryname(id, reducer = store.getState()) {
  const categories = reducer?.catalogReducer?.categories;
  if (!categories) return '';

  let categoryTagDetails = categories.find((categoryItem) => id === categoryItem?.id);

  // if categoryTagDetails is undefined return "all" as category name
  if (!categoryTagDetails) return 'all';

  if (!categoryTagDetails?.name) {
    const tags = reducer?.catalogReducer?.productTags;
    categoryTagDetails = tags?.find((tagItem) => id === tagItem?.id);
  }

  return categoryTagDetails?.name;
}

export function getCategoryTagNameFromId(id) {
  return getCategoryname(id);
}

export function getCategoryTagNameFromIdSSR(id, domain) {
  const reducer = getSSRStore(domain);
  const categoryName = getCategoryname(id, reducer);
  return categoryName?.replace(/ /g, '').replace(/\//g, '-');
}
